import React from "react";
import { HashRouter, Route, Switch, Redirect, BrowserRouter } from "react-router-dom";
// components
import Layout from "./Layout/Layout";
// pages
import Error from "../pages/error";
import Login from "../pages/login";
import Infragaadi from "../Infragaadi/components/Layout/Layout";
import khetiguru from "../Khetiguru/components/Layout/Layout";


// context
import { useUserState } from "../context/UserContext";
// hooks
import { useSessionTimeout } from "../hooks/useSessionTimeout";

export default function App() {
  // global

  var { isAuthenticated } = useUserState();

  // Initialize session timeout hook (30 minutes inactivity logout)
  useSessionTimeout();

  return (
    <BrowserRouter>
      <Switch>

        <Route
          exact
          path="/app"
          render={() => <Redirect to="/app/dashboard" />}
        />
        <PrivateRoute path="/app" component={Layout} />

        {/* ssssss @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */}

        <Route
          exact
          path="/infra"
          render={() => <Redirect to="/infra/EmpDashboard" />}
        />

        <PrivateRoute path="/infra" component={Infragaadi} />

        <Route
          exact
          path="/khetiguru"
          render={() => <Redirect to="/khetiguru/Dashboard" />}
        />

        <PrivateRoute path="/khetiguru" component={khetiguru} />


        {/*eeeee ############################################### */}
        <PublicRoute path="/login" component={Login} />
        <PublicRoute path="/" component={Login} />
        {/* <Route component={Error} /> */}
      </Switch>
    </BrowserRouter>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              exact
              to={{
                pathname: "/",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/app",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}









